import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GroupByPipe } from './group-by.pipe';
import { RemoveDecimalsCurrencyPipe } from './remove-decimals.pipe';
import { RemoveTagBrPipe } from './remove-tag-br/remove-tag-br.pipe';

@NgModule({
	declarations: [RemoveTagBrPipe, RemoveDecimalsCurrencyPipe, GroupByPipe],
	exports: [RemoveTagBrPipe, RemoveDecimalsCurrencyPipe, GroupByPipe],
	imports: [CommonModule],
})
export class PipesModule {}
